module.exports = __webpack_public_path__ + "static/media/car.2da73943.svg";